import { Box, Stack, Typography } from "@mui/material";
import { StyledButton } from "react-common-ui-library/FPACT/Buttons";
import { useIntl } from "react-intl";
import {
  CONTAINED,
  FPACT_EMAIL_ADDRESS,
  FPACT_EMAIL_ADDRESS_ID,
  FPACT_EMAIL_ADDRESS_SPAM_ID,
  H1,
  H3,
  LOGIN_ROUTE,
  SPAN,
} from "../../../Constants/CommonConstants";
import {
  EMAIL_SENT_ALERT_CONTENT_1,
  EMAIL_SENT_ALERT_HEADER,
  EMAIL_SENT_CONTENT_1,
  EMAIL_SENT_CONTENT_2,
  EMAIL_SENT_CONTENT_3,
  EMAIL_SENT_CONTENT_4,
  EMAIL_SENT_HEADER,
  FORGOT_USERNAME_HEADER,
  GO_TO_LOGIN,
} from "../../../Constants/ForgotUsernameConstants";
import { StyledTypographyHeader } from "../../../Styles/Common/CommonStyles";
import { GetUsernameButtonWrapper } from "../../../Styles/Login/ForgotUsername/ForgotUsernameStyles";
import ForgotUsernameInfoAlert from "./ForgotUsernameInfoAlert";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetIsUsernameRetrieved } from "../../../Features/LoginSlice";
import ConfigService from "../../../Services/ConfigService";

const fpactEmailAddress = ConfigService(FPACT_EMAIL_ADDRESS);

/**
 * @description Username sent page that will be displayed once the username email is sent.
 * @returns {ReactNode} Render the username email sent information.
 */
const UsernameSent = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onGoToLoginClick = () => {
    dispatch(resetIsUsernameRetrieved());
    navigate(`/${LOGIN_ROUTE}`);
  };
  return (
    <Stack spacing={8}>
      <Stack spacing={{ xs: 5.5, md: 5 }}>
        <StyledTypographyHeader
          id={FORGOT_USERNAME_HEADER}
          component={H1}
          variant={H3}
        >
          {intl.formatMessage({
            id: EMAIL_SENT_HEADER,
          })}
        </StyledTypographyHeader>
        <Stack spacing={2}>
          <Typography id={EMAIL_SENT_CONTENT_1}>
            {intl.formatMessage({
              id: EMAIL_SENT_CONTENT_1,
            })}
          </Typography>
          <Typography id={EMAIL_SENT_CONTENT_2}>
            {intl.formatMessage(
              { id: EMAIL_SENT_CONTENT_2 },
              {
                fpactEmail: (
                  <Box component={SPAN} id={FPACT_EMAIL_ADDRESS_ID}>
                    {fpactEmailAddress}
                  </Box>
                ),
                fpactEmailSpam: (
                  <Box component={SPAN} id={FPACT_EMAIL_ADDRESS_SPAM_ID}>
                    {fpactEmailAddress}
                  </Box>
                ),
                content3: (
                  <Box component={SPAN} id={EMAIL_SENT_CONTENT_3}>
                    {intl.formatMessage({ id: EMAIL_SENT_CONTENT_3 })}
                  </Box>
                ),
                content4: (
                  <Box component={SPAN} id={EMAIL_SENT_CONTENT_4}>
                    {intl.formatMessage({ id: EMAIL_SENT_CONTENT_4 })}
                  </Box>
                ),
              }
            )}
          </Typography>
        </Stack>
        <ForgotUsernameInfoAlert
          title={EMAIL_SENT_ALERT_HEADER}
          contentId={EMAIL_SENT_ALERT_CONTENT_1}
        />
      </Stack>
      <GetUsernameButtonWrapper>
        <Box>
          <StyledButton
            variant={CONTAINED}
            fullWidth
            id={GO_TO_LOGIN}
            onClick={onGoToLoginClick}
          >
            {intl.formatMessage({
              id: GO_TO_LOGIN,
            })}
          </StyledButton>
        </Box>
      </GetUsernameButtonWrapper>
    </Stack>
  );
};

export default UsernameSent;
